import type { Event } from '../types';

export const InviteV31TrackData = {
  ViewInviteeLoginPage: {
    eventAction: 'ViewInviteeLoginPage',
  } as Event<string>,
  ViewInviteeV31LoginPage: {
    eventAction: 'ViewInviteeV31LoginPage',
  } as Event<string>,
  ViewAcceptInvitePage: {
    eventAction: 'ViewAcceptInvitePage',
  } as Event<string>,
  ClickDownloadCta: {
    eventAction: 'ClickDownloadCta',
  } as Event<string>,
};
